// extracted by mini-css-extract-plugin
export default {"region":"RegionCard_region__lSSJ8","card":"RegionCard_card__QhhYt","title":"RegionCard_title__6m3EA"};